<template>
  <section
    id="final-cta"
    class="big-cta reveal"
    data-ga-section="final_cta"
  >
    <div
      class="floating-icons"
      aria-hidden="true"
    >
      <div class="fi f1">
        <icon-heart-filled
          :width="28"
          :height="28"
        />
      </div>
      <div class="fi f2">
        <icon-chat
          :size="28"
          :stroke-width="2"
        />
      </div>
      <div class="fi f3"><icon-bolt :size="28" /></div>
      <div class="fi f4">
        <icon-heart-filled
          :width="28"
          :height="28"
        />
      </div>
    </div>
    <h2>
      {{ trans.get('landing.big_cta.title_prefix')
      }}<span class="grad">{{ trans.get('landing.big_cta.title_grad') }}</span
      >{{ trans.get('landing.big_cta.title_suffix') }}
    </h2>
    <p>{{ trans.get('landing.big_cta.text') }}</p>
    <div class="ctas ctas--centered">
      <button
        class="btn-primary"
        type="button"
        data-cta-location="final_cta"
        @click="openSignup"
      >
        {{ trans.get('landing.big_cta.cta') }}
      </button>
      <a
        :href="playStoreUrl"
        target="_blank"
        rel="noopener"
        class="btn-primary btn-primary--outline"
        data-ga-app-store
        data-cta-location="final_cta"
        :aria-label="trans.get('landing.common.open_google_play_aria')"
      >
        <icon-google-play />
        <span>{{ trans.get('landing.big_cta.app_cta') }}</span>
        <span class="arrow">→</span>
      </a>
    </div>
  </section>
</template>

<script>
import IconHeartFilled from '../icons/IconHeartFilled.vue';
import IconChat from '../icons/IconChat.vue';
import IconBolt from '../icons/IconBolt.vue';
import IconGooglePlay from '../icons/IconGooglePlay.vue';
import { buildPlayStoreUrl } from '../../../analytics/ga4';

export default {
  name: 'BigCtaSection',
  components: { IconHeartFilled, IconChat, IconBolt, IconGooglePlay },
  computed: {
    playStoreUrl() {
      return buildPlayStoreUrl('final_cta');
    },
  },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', {
        mode: 'register',
        cta_location: 'final_cta',
      });
    },
  },
};
</script>
<style scoped lang="scss">
.big-cta {
  position: relative;
  z-index: 5;
  margin: 120px auto;
  max-width: 1380px;
  padding: 80px 56px;
  border-radius: 40px;
  background: linear-gradient(135deg, #170810 0%, #2d1420 50%, #c63e7c 130%);
  color: #fff;
  overflow: hidden;
  text-align: center;
}

.big-cta::before {
  content: '';
  position: absolute;
  top: -200px;
  right: -200px;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  background: radial-gradient(circle, var(--coral), transparent 60%);
  opacity: 0.4;
  filter: blur(40px);
}

.big-cta::after {
  content: '';
  position: absolute;
  bottom: -200px;
  left: -200px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, var(--pink), transparent 60%);
  opacity: 0.5;
  filter: blur(40px);
}

.big-cta > * {
  position: relative;
  z-index: 1;
}

.big-cta h2 {
  font-family: var(--display);
  font-size: clamp(40px, 5.6vw, 72px);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
  margin: 0 0 20px;
  text-wrap: balance;
}

/* .big-cta h2 .grad override (peach-coral on dark) lives in landing.scss. */

.big-cta p {
  font-size: 18px;
  opacity: 0.85;
  max-width: 620px;
  margin: 0 auto 38px;
  line-height: 1.5;
}

.ctas {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;
}

.big-cta .ctas {
  justify-content: center;
}

.big-cta .floating-icons {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.big-cta .floating-icons .fi {
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: grid;
  place-items: center;
  color: rgba(255, 255, 255, 0.5);
}

.big-cta .fi.f1 {
  top: 20%;
  left: 8%;
  transform: rotate(-12deg);
  animation: bob 6s ease-in-out infinite;
}

.big-cta .fi.f2 {
  top: 30%;
  right: 10%;
  transform: rotate(8deg);
  animation: bob 5s ease-in-out infinite -2s;
}

.big-cta .fi.f3 {
  bottom: 18%;
  left: 14%;
  transform: rotate(15deg);
  animation: bob 7s ease-in-out infinite -1s;
}

.big-cta .fi.f4 {
  bottom: 24%;
  right: 8%;
  transform: rotate(-8deg);
  animation: bob 5.5s ease-in-out infinite -3s;
}

@media (max-width: 1100px) {
  .big-cta {
    margin: 60px 20px;
    padding: 60px 28px;
  }
}

@media (max-width: 720px) {
  .big-cta .floating-icons {
    display: none;
  }
  .big-cta::before,
  .big-cta::after {
    display: none;
  }
}
</style>
